import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import jClassCard from 'src/components/modules/j-class-card.vue';
export default {
  name: 'pc-slides',
  components: {
    jClassCard: jClassCard
  },
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '轮播图区域',
          icon: 'el-icon-chat-line-round',
          content: {
            slidesList: [],
            rightNav: [{
              link: {},
              label: '我的订单',
              img: ''
            }, {
              link: {},
              label: '收藏清单',
              img: ''
            }, {
              link: {},
              label: '下单',
              img: ''
            }, {
              link: {},
              label: '报价单',
              img: ''
            }, {
              link: {},
              label: '对账单',
              img: ''
            }, {
              link: {},
              label: '发票',
              img: ''
            }],
            rightNews: [],
            newsLink: {}
          },
          attrs: {
            'label-width': '96px'
          },
          config: [{
            label: '轮播图区域',
            name: 'slidesList',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '右侧导航',
            name: 'rightNav',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '链接',
                value: 'link'
              }
            }
          }, {
            label: '右侧公告',
            name: 'rightNews',
            type: 'mapList',
            value: '',
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              url: {
                label: '标签',
                value: 'tag'
              },
              link: {
                label: '链接',
                value: 'link'
              },
              max: 3
            }
          }, {
            label: '公告更多连接',
            name: 'newsLink',
            type: 'link',
            value: ''
          }, {
            label: '文章是否自动获取',
            name: 'isAuto',
            type: 'switch'
          }]
        };
      }
    }
  },
  data: function data() {
    return {
      list: []
    };
  },
  computed: {
    nick: function nick() {
      if (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.userInfo.nick)) {
        return this.userInfo.nick.replace(/^(\d{3})\d*(\d{4})$/, '$1****$2');
      }
      return this.userInfo.nick;
    }
  },
  created: function created() {
    var _this = this;
    this.apiGet('/bbb/help/articleList', {
      pageSize: 3,
      bizType: 10
    }).then(function (res) {
      if (res.code == 200) {
        _this.list = res.data.content;
      }
    });
  },
  mounted: function mounted() {},
  methods: {}
};